
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum ValidationType {
	Email = 0,
	Phone = 1,
	Zip = 2,
	VatNumber = 3,
	DomainNonDk = 4,
	DomainDk = 5,
	Domain = 6,
	Percent = 7,
	EAN13 = 8,
	Folder = 9
}
export namespace ValidationType {
	export function getKeys(): Map<ValidationType, string> {
		return new Map([[0, 'Email'], [1, 'Phone'], [2, 'Zip'], [3, 'VatNumber'], [4, 'DomainNonDk'], [5, 'DomainDk'], [6, 'Domain'], [7, 'Percent'], [8, 'EAN13'], [9, 'Folder']]);
	}
}
